import React from 'react'
import { TableRowField } from '../../../../components'

export const topStoreVisitorXS = [
    {
        dataField: 'xs',
        text: 'Tienda',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Nombre:' value={row.name} />
                    <TableRowField label='Email:' value={row.phone} />
                    <TableRowField label='Visitantes:' value={row.visitors} />
                </div>
            )
        }
    }
]

export const topStoreVisitor = [
    {
        dataField: 'name',
        text: 'Nombre'
    },
    {
        dataField: 'phone',
        text: 'Telefono'
    },
    {
        dataField: 'visitors',
        text: 'Visitantes',
    }
]


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardTopVisitors/_columns.js